import { Input } from '@/components/ui/input';
import { FieldError } from '@/components/ui/field-error';
import { eventFormClasses } from '@/lib/utils/events.utils';

type FormNumberFieldProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  field: any;
  label: string;
  placeholder?: string;
  min?: number;
  forceShowErrors?: boolean;
  externalErrors?: string[];
};

/**
 * Reusable number input field component for TanStack Form
 */
export function FormNumberField({
  field,
  label,
  placeholder,
  min,
  forceShowErrors = false,
  externalErrors = [],
}: FormNumberFieldProps) {
  const errors = externalErrors.length > 0 ? externalErrors : (field.state.meta.errors || []);
  const hasErrors = errors.length > 0;
  const showErrors = forceShowErrors || field.state.meta.isTouched;
  const isInvalid = showErrors && hasErrors;

  return (
    <div className="space-y-2">
      <label className={eventFormClasses.label} htmlFor={field.name}>
        {label}
      </label>
      <Input
        id={field.name}
        name={field.name}
        type="number"
        inputMode="numeric"
        min={min}
        value={field.state.value ?? ''}
        onChange={(event) =>
          field.handleChange(
            event.target.value === '' ? undefined : Number(event.target.value)
          )
        }
        onBlur={field.handleBlur}
        aria-invalid={isInvalid || undefined}
        placeholder={placeholder}
        className={`${eventFormClasses.input} ${isInvalid ? 'border-red-500' : ''}`}
      />
      {showErrors && <FieldError errors={errors} />}
    </div>
  );
}

